<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>设置国家邮费</span>
				<el-button class="button" @click="AddTemplate" type="success">批量添加国家邮费规则</el-button>
			</div>
		</template>
		<div class="col">
			<el-table :data="list" border style="width: 100%" :header-cell-style="{'text-align':'center'}"
				:cell-style="{'text-align':'center'}">
				<el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="country_name" label="国家名称"></el-table-column>
				<el-table-column prop="postage_price" label="邮费"></el-table-column>
				<el-table-column prop="add_time" label="添加时间/修改时间"></el-table-column>
				<el-table-column fixed="right" label="操作" width="150">
					<template #default="scope">
						<el-button @click="ModifyTemplateDelivery(scope.row)" type="primary" size="mini">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible" @close="closeDialogAddgsVisible"
		:close-on-click-modal="false">
		<el-form :model="item1" ref="form" :rules="rules">
			<el-form-item label="国家名称" prop="country_name">
				<el-checkbox-group v-model="item1.country_name" size="medium">
					<span v-for="(city,index) in cities" :key="index">
						<el-checkbox-button :style="{border:borderChange,marginTop:marginTop}" v-for="(ite,i) in city"
							:label="ite" :disabled="disabledCountry.includes(ite)" :key="i">{{ite}}</el-checkbox-button>
						<br>
						<br>
					</span>
					<!-- </span> -->
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="邮费价格" prop="postage_price">
				<el-input placeholder="请填写邮费价格" v-model="item1.postage_price" size="small"></el-input>
			</el-form-item>

		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>

</template>

<script>
	export default {
		data() {

			return {
				title: '批量添加国家邮费规则',
				dialogFormVisible: false,
				list: [],
				borderChange: '1px grey solid',
				marginTop: '10px',
				disabledCountry: [], // 禁用的国家按钮
				countryAll: [], // 当前全部选中的国家 多条数据
				cities: [],
				postage_price: '',
				item1: {
					country_name: [],
					postage_price: ''
				},
				rules: {
					country_name: [{
						type: 'array',
						required: true,
						message: '请至少选择一个国家',
						trigger: 'click'
					}],
					postage_price: [{
						required: true,
						message: '请填写邮费价格',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			AddTemplate() {
				this.resetObj(this.item1)
				this.dialogFormVisible = true;
				this.getAllCountry();
				for (let i in this.countryAll) {
					this.disabledCountry.push(this.countryAll[i]);
				}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			closeDialogAddgsVisible() {
				this.$refs['form'].clearValidate();
				this.item1 = { //初始化formMsg中的值
					country_name: [],
					postage_price: '',
				}
				this.disabledCountry = [];
				this.countryAll = [];
			},
			getAllCountry() {
				let country_name_all = [];
				let str_country_name_all = '';
				for (let i in this.list) {
					country_name_all.push(this.list[i].country_name);
				}
				str_country_name_all = country_name_all.join(','); //拼接选中全部国家
				this.countryAll = str_country_name_all.split(','); //选中全部国家转为一维数组
			},
			ModifyTemplateDelivery(val) {
				// let temp = this.cloneObj(val);
				this.title = '编辑';
				// this.item1 = temp;
				this.dialogFormVisible = true;
				this.item1.postage_price = val.postage_price;
				// this.disabledCountry=['上海', '广州', '深圳','武汉'];//已经给国家添加过邮费   不要再添加了
				let country_name_checked = val.country_name.split(','); //选中的国家
				// console.log(country_name)
				for (let i in country_name_checked) {
					this.item1.country_name.push(country_name_checked[i]);
				}
				this.getAllCountry(); //获取全部选中的国家
				// console.log(this.countryAll);
				// console.log(this.item1.country_name);
				let countryAll_tem = [];
				for (let i in this.countryAll) {
					countryAll_tem.push(this.countryAll[i]);
				}
				let num = '';
				for (let i in this.item1.country_name) {
					num = countryAll_tem.indexOf(this.item1.country_name[i]); //获取出现在 当前条 数据  国家 的键
					countryAll_tem.splice(num, 1); //去除  出现在 当前条 数据  国家
				}
				//不在当前条数据 其他条数据选中 的国家 禁用
				for (let i in countryAll_tem) {
					this.disabledCountry.push(countryAll_tem[i]);
				}
				// console.log(this.disabledCountry);
				this.item1.id = val.id;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			getCountryTemplate() {
				let pde_id = this.$route.query.pde_id;
				this.httpPost({
					url: '/admin/product/productSetCountryTemplate',
					data: {
						pde_id: pde_id
					}
				}).then((re) => {
					this.list = re.data.checked_country;
					this.cities = re.data.all_country;
					this.postage_price = re.data.postage_price;
					// console.log(this.cities);
				})
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.httpPost({
							url: '/admin/product/productSetCountryTemplateUpdate',
							data: {
								pde_id: this.$route.query.pde_id,
								id: this.item1.id,
								country_name: this.item1.country_name,
								postage_price: this.item1.postage_price
							}
						}).then((re) => {
							if (re.code > 1) return this.alertWarn('错误')
							this.alertSuccess('成功')
							this.dialogFormVisible = false;
							this.resetObj(this.item1)
							this.getCountryTemplate();
						}).catch((err) => {
							this.alertWarn('失败')
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			}
		},
		created() {
			this.fullscreenLoading = true;
			this.getCountryTemplate();
		}
	}
</script>

<style>
</style>